module.exports = __webpack_public_path__ + "public/images/icons/cuba.dc73f6651e7b82b301dd3680229fc207.svg";